// extracted by mini-css-extract-plugin
export default {"tooltipTitle":"SanctionStatus_tooltipTitle__mIChF","tooltipText":"SanctionStatus_tooltipText__ywGgj","tooltipStatusText":"SanctionStatus_tooltipStatusText__Y46Db"};